<template>
  <div>
    <header class="header navbar-nav navbar-expand-md navbar-dark">
      <div class="container-fluid container-fluid--max">
        <div class="header__collapse-heading d-flex align-items-center d-md-none">
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#headerMenu" aria-controls="headerMenu" aria-expanded="false" aria-label="Déployer le menu">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="nav-item ml-auto d-flex align-items-center">
            <!-- <router-link :to="{ name: 'supportRequests' }" tag="a" class="header__notifications notifications header-nav__link" title="Notifications" aria-label="Notifications">
              <i class="header__icon notifications__icon fa fa-bell" aria-hidden=true>
                TODO(dev): max to display == 99+
                <span class="notifications__count smaller">9</span>
              </i>
            </router-link> -->
            <a class="header__logout btn btn-primary" title="Déconnexion" aria-label="Déconnexion" @click="signOut">
              <i class="fa fa-power-off" aria-hidden=true></i>
            </a>
          </div>
        </div>

        <nav class="header__uncollapse navbar justify-content-between d-none d-md-flex mt-2">
          <div>
            <a class="header__backlink nav-link thin" :href="$bestoveUrl" target="_blank" v-if="$appName === 'bestove'">
              <i class="fa fa-long-arrow-left mr-h" aria-hidden="true"></i>
              Retourner vers BESTOVE
            </a>
          </div>
          <div class="header__account navbar-nav">
            <!-- <router-link :to="{ name: 'supportRequests' }" tag="a" class="header__notifications notifications nav-link" title="Notifications" aria-label="Notifications">
              <i class="header__icon notifications__icon fa fa-bell" aria-hidden=true>
                TODO(dev): max to display == 99+
                <span class="notifications__count smaller">9</span>
              </i>
            </router-link> -->
            <div class="header-dropdown nav-item dropdown d-inline-block">
              <a class="header-dropdown__toggle nav-link dropdown-toggle text-capitalize" href="#" id="accountDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ name }}
              </a>
              <div class="header-dropdown__menu dropdown-menu dropdown-menu-right" aria-labelledby="accountDropdown">
                <button type="button" class="header-dropdown__link dropdown-item btn-link" @click="signOut">Déconnexion</button>
              </div>
            </div>
          </div>
        </nav>

        <nav class="header__collapse collapse navbar-collapse" id="headerMenu">
          <ul class="header-nav navbar-nav nav-pills" role="navigation">
            <li class="header-nav__item nav-item" v-for="(link, i) in links" :key="'nav-link' + i">
              <router-link :to="{ name: link.pathname }" class="header-nav__link nav-link" :class="{ 'active': isActive(link) }">
                {{ link.title }}
              </router-link>
            </li>
          </ul>
          <a class="header__backlink nav-item d-md-none" :href="$bestoveUrl" v-if="$appName === 'bestove'">
            <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
            Retourner vers BESTOVE
          </a>
        </nav>
      </div>
    </header>
    <api-error class="mt-4"></api-error>
  </div>
</template>

<script>
import ApiError from '@/components/layout/ApiErrorNotification'

export default {
  name: 'Navigation',
  components: {
    ApiError
  },
  props: {
    links: {
      type: Array,
      default: () => []
    },
    name: String
  },
  methods: {
    isActive (link) {
      return this.$route.meta.name === link.name
    },
    signOut () {
      this.$emit('sign-out')
    }
  }
}
</script>
